import { ColorsNeutral400 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const list = css({
  width: '100%',
});

const listItem = css({
  '&.MuiListItem-root': {
    alignItems: 'flex-start',
  },
});

const listItemText = css({
  '&.MuiTypography-root': {
    fontWeight: '500',
  },
});

const listItemTextSecondary = css({
  '&.MuiTypography-root': {
    color: ColorsNeutral400,
  },
});

const TeamRolesDescriptionStyles = {
  list,
  listItem,
  listItemText,
  listItemTextSecondary,
};

export default TeamRolesDescriptionStyles;
